export default "__VITE_ASSET__852a11ae__"